import cx from 'classnames';
import * as React from 'react';

import BoxHeader from 'components/BoxHeader';
import Image from 'components/Image';

import './styles/Box.scss';

import { Props as BoxHeaderProps } from 'components/BoxHeader';

export enum BoxColorEnum {
  paper = 'paper',
  info = 'info',
  whiteout = 'whiteout',
  eraser = 'eraser',
  elmer = 'elmer',
  elmerLight = 'elmerLight',
  globeLight = 'globeLight',
  none = 'none',
}

export type BoxColor = keyof typeof BoxColorEnum | BoxColorEnum;

export enum BoxTextAlignEnum {
  left = 'left',
  center = 'center',
  right = 'right',
}

export type BoxTextAlign = keyof typeof BoxTextAlignEnum | BoxTextAlignEnum;

export enum BoxSizeEnum {
  xlarge = 'xlarge',
  large = 'large',
  xmedium = 'xmedium',
  medium = 'medium',
  small = 'small',
  xsmall = 'xsmall',
  xxsmall = 'xxsmall',
}

export type BoxSize = keyof typeof BoxSizeEnum | BoxSizeEnum;
export type BoxBandHeaderSize = keyof typeof BoxSizeEnum | BoxSizeEnum;

export enum BoxHeaderSizeEnum {
  large = 'large',
  medium = 'medium',
  small = 'small',
  xsmall = 'xsmall',
}

export type BoxHeaderSize = keyof typeof BoxHeaderSizeEnum | BoxHeaderSizeEnum;

export type Props = {
  children?: React.ReactNode;
  className?: string;
  color?: BoxColor;
  headerImage?: string;
  onImageLoad?: () => void;
  size?: BoxSize;
  textAlign?: BoxTextAlign;
  headerSize?: BoxHeaderSize;
  noShadow?: boolean;
  inline?: boolean;
  noBorder?: boolean;
  noCenter?: boolean;
  noColor?: boolean;
  bandHeader?: React.ReactNode;
  bandHeaderSize?: BoxBandHeaderSize;
} & Pick<
  BoxHeaderProps,
  'dark' | 'glyph' | 'glyphColor' | 'image' | 'imageSize' | 'serif' | 'subtext' | 'title' | 'icon'
>;

type DefaultProps = {
  color: BoxColor;
  textAlign: BoxTextAlign;
};

export default class Box extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    color: BoxColorEnum.whiteout,
    textAlign: BoxTextAlignEnum.center,
  };

  render() {
    const {
      children,
      className,
      color,
      dark,
      glyph,
      glyphColor,
      headerImage,
      image,
      imageSize,
      inline,
      onImageLoad,
      serif,
      size,
      subtext,
      title,
      textAlign,
      headerSize,
      noShadow,
      noBorder,
      noCenter,
      bandHeader,
      bandHeaderSize,
      icon,
    } = this.props;
    return (
      <div
        className={cx(
          'Box',
          color && `Box--${color}`,
          size && `Box--${size}`,
          textAlign && `Box--${textAlign}`,
          noShadow && 'Box--noShadow',
          noBorder && 'Box--noBorder',
          noCenter && 'Box--noCenter',
          inline && 'Box--inline',
          className
        )}
      >
        {headerImage && (
          <Image src={headerImage} className="Box-headerImage" onLoad={onImageLoad} />
        )}
        {bandHeader && (
          <div
            className={cx(
              'Box-bandHeader',
              bandHeaderSize && `Box-bandHeader--${bandHeaderSize}`,
              className
            )}
          >
            {bandHeader}
          </div>
        )}
        {(glyph || image || icon || title || subtext) && (
          <BoxHeader
            icon={icon}
            glyph={glyph}
            glyphColor={glyphColor}
            image={image}
            imageSize={imageSize}
            title={title}
            subtext={subtext}
            dark={dark}
            flush
            size={headerSize}
            serif={serif}
          />
        )}
        {children}
      </div>
    );
  }
}
